import { FC, useRef, useEffect, useState, ReactElement } from 'react';
import DefaultButton from 'src/components/atoms/buttons/DefaultButton';
import { useNavigate, useLocation } from 'react-router-dom';
import { flowMenuDataStore } from 'src/store/menu';
import { linkMainMenu } from 'src/utils/menuSet';
import { stepViewStore } from 'src/store/stepData';
import './style.scss';

interface Props {
  label: string;
  icon?: string;
  desc?: ReactElement;
  content: ReactElement;
  styleDef?: React.CSSProperties;
  confitmEvent?: () => void;
  num: number;
  viewType?: string;
}

const MainBoxLayout: FC<Props> = ({
  content,
  icon,
  label,
  desc,
  styleDef,
  num,
  confitmEvent,
  viewType,
}) => {
  const navigate = useNavigate();
  const stepView = flowMenuDataStore((state: any) => state.data);
  const bindStepView = flowMenuDataStore((state: any) => state.bind);
  const topRef = useRef<HTMLDivElement>(null);

  const { state } = useLocation();
  const initPageNum: number = state?.pageNum || 0;
  // const [selectedPageNum, setSelectedPageNum] = useState<number>(initPageNum);

  const nextClickEvt = () => {
    const nextNum = num + 1;
    // setSelectedPageNum(nextNum);
    linkMainMenu({ num: nextNum, navigate: navigate });
  };
  const prevClickEvt = () => {
    const nextNum = num - 1;
    // setSelectedPageNum(nextNum);
    linkMainMenu({ num: nextNum, navigate: navigate });
  };

  useEffect(() => {
    topRef.current?.scrollIntoView({
      behavior: 'smooth', // 또는 'auto'
      block: 'start',
    });
  }, [num]);

  const topNaviDiv = () => {
    const prebtnDiv = () => {
      return (
        <div className="_prev_btn _btn">
          <DefaultButton
            text="이전"
            clickEvent={e => prevClickEvt()}
            icon="ri-arrow-left-s-line"
            type="type1"
            styleDef={{ width: '90px', height: '32px' }}
          />
        </div>
      );
    };
    const nextbtnDiv = () => {
      return (
        <div className="_next_btn _btn">
          <DefaultButton
            text="다음"
            clickEvent={e => nextClickEvt()}
            icon="ri-arrow-right-s-line"
            type="type2"
            styleDef={{ width: '70px', height: '32px', fontSize: '13px' }}
          />
        </div>
      );
    };

    if (num === 0) {
      return <div className="_top_navi">{nextbtnDiv()}</div>;
    }
    if (num === 4) {
      return <div className="_top_navi">{prebtnDiv()}</div>;
    }
    if (num !== 0 && num !== 4) {
      return (
        <div className="_top_navi">
          {prebtnDiv()}
          {nextbtnDiv()}
        </div>
      );
    }

    return '';
  };

  return (
    // <div className={['_main_content_layout', stepView.viewType].join(' ')}>
    <div className={['_main_content_layout'].join(' ')} ref={topRef}>
      {/* <div className="_label_div">
        <div className="_label">{label}</div>
        {topNaviDiv()}
      </div> */}
      <div className="_content_div" style={styleDef}>
        <div className="_top_div">
          <div className="_label_div">
            <div className="_label">
              {icon ? (
                <div className="_icon">
                  <i className={icon} />
                </div>
              ) : (
                ''
              )}
              <div className="_tit">{label}</div>
            </div>
            <div className="_desc">{desc}</div>
          </div>
          {/* {topNaviDiv()} */}
        </div>
        <div className="_content">{content}</div>
      </div>
      {num !== 4 ? (
        <div className="_bottom_div">
          <DefaultButton
            text="확인"
            clickEvent={e => nextClickEvt()}
            icon=""
            type="type5"
            styleDef={{ width: '280px', height: '45px' }}
          />
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default MainBoxLayout;
